module.exports = __webpack_public_path__ + "static/media/12x16no2.19e3e75c.jpg";